module.exports = __webpack_public_path__ + "static/media/vacancy-banner.8a4f03cf.png";